import cls from 'classnames';
import { useScreenType } from '@/hooks/media';
import { ActivityStatus, activityInfo } from '@/types';
import { useFm } from '@web3/base-hooks';
import {
  normalizeLink,
  toFormat,
  appPath,
  replaceBybitToLocationHost,
} from '@web3/base-utils';
import Link from 'next/link';
import { removeFloatZero } from '@/utils/number';
import { Page } from '@/config/track-config';

const iconDefault = `${appPath}/svg/home/icon-default.svg`;

type IDailyActivityCard = {
  data: activityInfo;
};

export function DailyActivityCard(props: IDailyActivityCard) {
  const { isMobile } = useScreenType();
  const { data } = props;
  const fm = useFm();

  return (
    <Link
      className="w-full h-full"
      href={
        // isMobile ? 'javascript: void(0)' :
        normalizeLink(
          `/activity?activityId=${data.activityId}&activityTag=${data.activityTag}`
        )
      }
      // onClick={onActivityClick}
      data-spm-even="Web3UserClick"
      data-spm-data={JSON.stringify({
        page_name: Page.AirdropArcadeHome,
        button_name: 'DailyRewards',
        activity_index: data.activityId,
      })}
    >
      <div
        className={cls([
          'daily-activity-item text-white relative flex flex-col justify-between',
          isMobile && 'daily-activity-item-h5',
        ])}
      >
        <div
          className={cls([
            'absolute top-0 right-0 z-9 status',
            data.activityStatus === ActivityStatus.upcoming
              ? ' status-upcoming'
              : data.activityStatus === ActivityStatus.progress
                ? ' status-progress'
                : ' status-ended',
          ])}
        >
          {data.activityStatus === ActivityStatus.upcoming
            ? fm('status_upcoming')
            : data.activityStatus === ActivityStatus.progress
              ? fm('status_progress')
              : fm('status_ended')}
        </div>
        <div>
          <div className="flex gap-6 items-center">
            <img
              className="w-12 h-12 rounded-full"
              src={
                replaceBybitToLocationHost(data.rewardInfos[0]?.icon) ||
                replaceBybitToLocationHost(data.bizIconUrl) ||
                iconDefault
              }
              alt=""
            />
            <div className="">
              <h2
                className="text-2xl !md:text-3xl font-semibold"
                style={{
                  whiteSpace: 'nowrap',
                }}
              >
                {data.rewardDesc ? (
                  data.rewardDesc
                ) : data.rewardInfos[0] ? (
                  <>
                    <span className="mr-2">
                      {toFormat(removeFloatZero(data.rewardInfos[0]?.amount))}
                    </span>
                    {data.rewardInfos[0]?.symbol}
                  </>
                ) : undefined}
              </h2>
            </div>
          </div>
          <div className="my-3 !md:mt-6 h-[1px] w-full bg-[#1E2023]"></div>
        </div>
        <div>
          <h3 className="text-lg !md:text-xl font-normal line-clamp-2">
            {data.activityTitle}
          </h3>
          <p className="text-sm font-light mt-1 line-clamp-2">
            {data.activitySubtitle}
          </p>
        </div>
      </div>
    </Link>
  );
}
